import { CreditCard, ExternalLink } from "lucide-react";

export const CardPaymentButton = ({ enabled, selected, loading, payCard }) => (
  <>
    <button type="button" onClick={payCard} disabled={loading || !selected || !enabled} data-testid="tip-pay-card-button" className="w-full inline-flex items-center justify-center gap-2 px-4 py-4 rounded-full bg-amber-400 text-ink font-bold uppercase text-sm hover:scale-[1.02] active:scale-95 transition-transform disabled:opacity-60">
      <CreditCard size={16} className="shrink-0" />{loading ? "Redirection…" : `Carte bancaire — ${selected?.amount ?? ""} €`}
    </button>
    {!enabled && <p className="text-xs text-slate-400" data-testid="tip-card-unavailable">Carte bancaire indisponible.</p>}
  </>
);

export const PaypalPaymentButton = ({ url, selected }) => {
  if (!url || !selected) return <p className="text-xs text-slate-400" data-testid="tip-paypal-unavailable">PayPal indisponible pour le moment.</p>;
  const href = `${url}/${selected.amount.toFixed(2)}EUR`;
  return <>
    <a href={href} data-testid="tip-pay-paypal-button" className="w-full inline-flex items-center justify-center gap-2 px-4 py-4 rounded-full border border-[#60A5FA]/60 text-[#93C5FD] font-bold uppercase text-sm hover:bg-[#60A5FA]/10 transition-colors">
      PayPal — {selected.amount} €<ExternalLink size={14} className="shrink-0" />
    </a>
    <p className="text-xs text-slate-400" data-testid="tip-paypal-notice">Confirmation sur PayPal. Le compte destinataire ne peut pas se payer lui-même.</p>
  </>;
};